interface DonationYearFilterProps {
  donationYears: number[]
  activeDonationYear: number
  onChange: (year: number) => void
}

export default function DonationYearFilter({
  donationYears,
  activeDonationYear,
  onChange,
}: DonationYearFilterProps) {
  const handleDonationYearChange = (year: number) => {
    onChange(year)
  }

  return (
    <select
      key={`select-${activeDonationYear}`}
      className="select ta-l w-50%@md"
      value={activeDonationYear}
      onChange={(e) => handleDonationYearChange(Number(e.target.value))}
    >
      {donationYears.map((year) => (
        <option key={year} value={year}>
          {year}
        </option>
      ))}
    </select>
  )
}
